import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param coordinates Array Asset of latitude longitude objects
 *
 * @return {Promise<any>|Promise}
 */
export default (function (coordinates) {
    if (coordinates === void 0) { coordinates = []; }
    var url = applyPathVariables(EndPoints.LOCATION_LOOKUP_BATCH, {});
    var request = new Request({ method: Methods.POST, url: url, withCredentials: true, data: coordinates });
    return request.execute();
});
